<template>
  <!-- popover page contents -->
  <div class="popup popup-invoice-title">
    <div class="page flex-col">
      <div class="bd1 flex-col">
        <div class="layer2 flex-col" style="background: #FFFFFF;">
          <div class="outer1 flex-col" style="background-color: rgba(250, 250, 250, 1);">
            <div class="layer3 flex-row">
              <img
                class="icon2"
                referrerpolicy="no-referrer"
                src="/static/img/svg/sousuo.svg"
              />
              <input class="txt1" placeholder="请输入单位名称                      " v-model.trim="query" style="border: none;background-color: rgba(250, 250, 250, 1);"/>
              <span style="width: 28px;height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular; color: rgb(151, 151, 151);
              float: right;
              right: 5px;
              margin-right: 10px;
              position: fixed;" @click="close">取消</span>
            </div>
          </div>
        </div>
<!--        <div style="background: #FFFFFF; ">-->
<!--          <div class="searchbar searchbar-active" style="width: 355px;margin-left: 10px;">-->
<!--            <a  class="searchbar-cancel1 close-popup" style="width: 28px;height: 20px;font-size: 14px;font-family: PingFangSC-Regular, PingFang SC;color: #979797;">取消</a>-->
<!--            <div class="search-input">-->
<!--              <label class="icon icon-search" for="searchEnterprise"></label>-->
<!--              <input type="search" v-model.trim="query" id="searchEnterprise" placeholder='请输入单位名称'/>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
         <div style="margin-top: 45px" class="enterprise">
              <span class="infoBox1"  v-for="(company, index) in filteredData"  @click="valueConvey(company,index)">
           {{company.enterpriseInvoiceTitle}}
             <div class="full-split-line" style="margin-top: 10px"></div>
        </span>
         </div>

      </div>
    </div>
<!--    <header class="bar bar-nav close-popup">-->
<!--      <router-link class="button button-link button-nav pull-right" :to="{}">-->
<!--        <span class="icon icon-down"></span>-->
<!--      </router-link>-->
<!--      <h1 class='title'>发票抬头单位搜索</h1>-->
<!--    </header>-->
<!--    <div class="layer2 flex-col">-->
<!--      <div class="outer1 flex-col">-->
<!--        <div class="layer3 flex-row">-->
<!--          <img-->
<!--            class="icon2"-->
<!--            referrerpolicy="no-referrer"-->
<!--            src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng91ba4e98688d2f971ac4750f434766587247962cb355e063404f7deecc1c4172"-->
<!--          />-->
<!--          <input type="search" v-model.trim="query"  class='txt1' id="searchEnterprise" placeholder='请输入单位名称'/>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="bar bar-header-secondary">-->
<!--      <div class="searchbar">-->
<!--        <a @click="valueConvey2" class="searchbar-cancel close-popup">确认</a>-->
<!--        <div class="search-input">-->
<!--          <label class="icon icon-search" for="searchEnterprise"></label>-->
<!--          <input type="search" v-model.trim="query" id="searchEnterprise" placeholder='请输入单位名称'/>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div style="height: 68px;"></div>-->
<!--    <div class="list-block" style="background-color: #FAFAFA">-->
<!--      <ul style="border-bottom: none;background-color: #FAFAFA;margin-left: 15px;margin-right: 15px;border-top: 1px solid #EFEEF3;">-->
<!--        <li @click="valueConvey(company,index)" v-for="(company, index) in filteredData" style="border-bottom: 1px solid #EFEEF3;">-->
<!--          <div class="item-content" style="padding-left: 0px;padding-right: 5px">-->
<!--            <div  style="height: 40px;-->
<!--font-size: 14px;-->
<!--font-family: PingFangSC-Regular, PingFang SC;-->
<!--font-weight: 400;-->
<!--color: #424242;-->
<!--line-height: 20px;">-->
<!--              <div >-->
<!--                {{company.enterpriseInvoiceTitle}}-->
<!--              </div>-->
<!--              <div>-->
<!--                <span v-model="enterpriseInvoiceTaxRegNo">{{company.enterpriseInvoiceTaxRegNo}}</span>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </li>-->
<!--      </ul>-->
<!--    </div>-->
    <div class="background-modal" v-if="showChoosePayEnterprise"></div>
    <div class="choose-balance-account" v-show="showChoosePayEnterprise">
      <div class="content-block">
        <div class="block-item" style="justify-content: center;text-align: center">
          <span class="word3">该发票抬头对应多个单位</span>
          <span class="info1">请选择支付单位</span>
          <div v-for="data in enterpriseList">
            <div class="group3 flex-col"></div>
            <span class="word4" @click="choosePayEnterprise(data)">{{data.enterpriseName}}</span>
          </div>
          <div class="group3 flex-col"></div>
          <div class="block-item" style="justify-content: center;text-align: center;margin-top: 10px">
            <span class="word3" @click="cancel">取消</span>
          </div>
        </div>
        <div class="split-line"></div>
        <div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapMutations} from 'vuex'
  import EMKT from '../../emkt'
  import $ from 'jquery'

  export default {
    mounted () {
      this.removeChoose()
      let enterprise = $('.popup-invoiceTitle')
      enterprise.on('open', function () {
        EMKT.setStoreItem('invoiceTitlePopupFlag', true)
        console.log('popup is opening')
      })
      enterprise.on('closed', function () {
        EMKT.setStoreItem('invoiceTitlePopupFlag', false)
        console.log('popup closed')
      })
    },
    created () {
      // 组件创建完后获取数据，
      // 此时 data 已经被 observed 了
      this.fetchData()
    },
    data () {
      return {
        query: '',
        data: {},
        filteredData: {},
        showChoosePayEnterprise: false,
        enterpriseList: [],
        InvoiceTitleMap: null,
        payEnterpriseChooseList: []
      }
    },
    watch: {
      // listening to input
      'query': function (query) {
        console.log('in query')
        let _this = this
        _this.initialize()
        let data = _this.data
        let filteredData = _this.filteredData
        for (let i = 0; i < data.length; i++) {
          if (data[i]['enterpriseInvoiceTitle'].match(query.toLowerCase())) {
            let item = {
              'enterpriseInvoiceTitle': data[i].enterpriseInvoiceTitle
            }
            filteredData.push(item)
            // console.log(_this.filteredData)
            if (filteredData.length > 19) {
              break
            }
          }
        }
      }
    },
    methods: {
      ...mapMutations([
        'INVOICETITLE_INFO_UPDATE'
      ]),
      fetchData () {
        // fetching data from localstorage
        this.data = EMKT.getLocalStorage('EmktEnterpriseInvoiceTitleList')
        this.InvoiceTitleMap = EMKT.getLocalStorage('EmktFirstLevelInvoiceTitleMap')
        console.log('EMKT.getLocalStorage(\'EmktFirstLevelEnterpriseList\')', EMKT.getLocalStorage('EmktEnterpriseInvoiceTitleList'))
      },
      initialize () {
        this.filteredData = []
      },
      removeChoose () {
        this.INVOICETITLE_INFO_UPDATE('')
      },
      valueConvey (company, index) {
        let _this = this
        let enterprise = this.InvoiceTitleMap[company.enterpriseInvoiceTitle]
        _this.enterpriseList = this.InvoiceTitleMap[company.enterpriseInvoiceTitle].enterpriseList
        if (_this.enterpriseList !== undefined && _this.enterpriseList.length > 1) {
          _this.showChoosePayEnterprise = true
        } else {
          var choice = {
            'enterpriseInvoiceTitle': _this.filteredData[index].enterpriseInvoiceTitle,
            'enterpriseNo': enterprise.enterpriseList[0].enterpriseNo
          }
          _this.INVOICETITLE_INFO_UPDATE(choice)
          _this.query = ''
          $.closeModal('.popup-invoice-title')
        }
      },
      valueConvey2 () {
        let _this = this
        var choice = {
          'enterpriseInvoiceTitle': _this.query,
          'enterpriseNo': ''
        }
        _this.INVOICETITLE_INFO_UPDATE(choice)
      },
      cancel () {
        this.showChoosePayEnterprise = false
      },
      close () {
        $.closeModal('.popup-invoice-title')
      },
      choosePayEnterprise (data) {
        var choice = {
          'enterpriseInvoiceTitle': data.enterpriseInvoiceTitle,
          'enterpriseNo': data.enterpriseNo
        }
        this.INVOICETITLE_INFO_UPDATE(choice)
        this.query = ''
        this.showChoosePayEnterprise = false
        $.closeModal('.popup-invoice-title')
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .background-modal {
    opacity: 0.55;
    background: #000000;
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 10;
  }
  .full-split-line {
    border-top: .5px solid #efeef3;
    margin-right: 15px;
    height: 1px;
  }
  .choose-balance-account {
    position: absolute;
    bottom: 35vh;
    background-color: white;
    border-radius: 12px;
    height: 280px;
    left: 28px;
    right: 28px;
    margin: 0 10px;
    z-index: 20;
    font-size: 14px;
    color: #979797;
  }
  .word3{
    color: rgba(0, 0, 0, 0.9);
    font-size: 17px;
    font-family: PingFangSC-Medium;
    line-height: 23px;
    text-align: center;
    align-self: center;
  }
  .info1{
    display: block;
    overflow-wrap: break-word;
    color: rgba(0, 0, 0, 0.5);
    font-size: 17px;
    font-family: PingFangSC-Regular;
    line-height: 23px;
    text-align: center;
    align-self: center;
    margin-top: 16px;
  }
  .word4 {
    display: block;
    overflow-wrap: break-word;
    color: rgba(87, 107, 149, 1);
    font-size: 17px;
    letter-spacing: 1px;
    font-family: PingFangSC-Medium;
    line-height: 23px;
    text-align: center;
    align-self: center;
    margin-top: 15px;
  }
  .group3 {
    height: 1px;
    background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng43d79a35b1a4030f9e5fe1e357ff65c4486cd26868f17904dc24db64dab0ae4d)
    100% no-repeat;
    align-self: center;
    margin-top: 20px;
  }
  .page {
    z-index: 1;
    position: relative;
    width: 100%;
    overflow-y:scroll;
    overflow-x:hidden;
    height:100vh;
    background-color: rgba(250, 250, 250, 1);
    justify-content: flex-start;
    padding-top: 0;
  }

  .bd1 {
    z-index: auto;
    width: 100%;
  }
  .layer1 {
    z-index: 31;
    height: 88px;
    background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngd89d0f689b86ca6009ae4505c0ccc62515c408f2caf0db29bfb421754d66ec8f)
    100% no-repeat;
    align-self: center;
    width: 375px;
  }

  .mod1 {
    z-index: auto;
    width: 340px;
    height: 18px;
    margin: 15px 0 0 21px;
  }

  .word1 {
    z-index: 67;
    width: 54px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(255, 255, 255, 1);
    font-size: 15px;
    letter-spacing: -0.30000001192092896px;
    font-family: SFProText-Semibold;
    line-height: 18px;
    text-align: center;
  }

  .icon1 {
    z-index: 61;
    width: 17px;
    height: 11px;
    margin: 3px 0 0 219px;
  }

  .group1 {
    z-index: 57;
    width: 16px;
    height: 11px;
    background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngb3bbe96fea0140cfc24043ebc96677b3c6566f6cd0b99cb137439fb58271c764)
    0px 0px no-repeat;
    margin: 3px 0 0 5px;
  }

  .label1 {
    z-index: 53;
    width: 25px;
    height: 12px;
    margin: 2px 0 0 4px;
  }

  .mod2 {
    z-index: auto;
    width: 369px;
    height: 44px;
    margin-top: 11px;
  }

  .label2 {
    z-index: 48;
    width: 40px;
    height: 44px;
  }

  .word2 {
    z-index: 47;
    width: 68px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(0, 0, 0, 0.9);
    font-size: 17px;
    font-family: PingFangSC-Medium;
    line-height: 24px;
    text-align: center;
    margin: 10px 0 0 114px;
  }

  .img1 {
    z-index: 33;
    width: 87px;
    height: 32px;
    margin: 6px 0 0 60px;
  }

  .layer2 {
    z-index: 3;
    height: 42px;
    position: fixed;
    top: 0px;
    background-color: rgba(255, 255, 255, 1);
    align-self: center;
    width: 100%;
    justify-content: center;
  }

  .outer1 {
    z-index: 5;
    height: 32px;
    border-radius: 16px;
    background-color: rgba(250, 250, 250, 1);
    justify-content: center;
    align-items: flex-start;
    margin-left: 15px;
    margin-right: 53px;
  }

  .layer3 {
    z-index: auto;
    height: 20px;
    justify-content: space-between;
  }

  .icon2 {
    z-index: 6;
    width: 14px;
    height: 14px;
    margin-top: 3px;
    margin-left: 10px;
  }

  .txt1 {
    z-index: 10;
    display: block;
    width: 280px;
    overflow-wrap: break-word;
    /*color: rgba(151, 151, 151, 1);*/
    font-size: 14px;
    font-family: PingFangSC-Regular;
    line-height: 20px;
    text-align: left;
    margin-left: 5px;
    height: 100%;
  }

  .infoBox1 {
    z-index: 11;
    display: block;
    height: 40px;
    overflow-wrap: break-word;
    color: rgba(66, 66, 66, 1);
    font-size: 14px;
    font-family: PingFangSC-Regular;
    line-height: 20px;
    text-align: left;
    margin-left: 20px;
    margin-top: 5px;
  }

  .paragraph1 {
    z-index: 12;
    width: 350px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(66, 66, 66, 1);
    font-size: 14px;
    font-family: PingFangSC-Regular;
    line-height: 20px;
    text-align: left;
    align-self: flex-end;
    margin-top: 10px;
  }

  .paragraph2 {
    z-index: 15;
    width: 350px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(66, 66, 66, 1);
    font-size: 14px;
    font-family: PingFangSC-Regular;
    line-height: 20px;
    text-align: left;
    align-self: flex-end;
    margin-top: 10px;
  }

  .paragraph3 {
    z-index: 17;
    width: 350px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(66, 66, 66, 1);
    font-size: 14px;
    font-family: PingFangSC-Regular;
    line-height: 20px;
    text-align: left;
    align-self: flex-end;
    margin-top: 10px;
  }

  .paragraph4 {
    z-index: 19;
    width: 350px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(66, 66, 66, 1);
    font-size: 14px;
    font-family: PingFangSC-Regular;
    line-height: 20px;
    text-align: left;
    align-self: flex-end;
    margin-top: 10px;
  }

  .paragraph5 {
    z-index: 21;
    width: 350px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(66, 66, 66, 1);
    font-size: 14px;
    font-family: PingFangSC-Regular;
    line-height: 20px;
    text-align: left;
    align-self: flex-end;
    margin-top: 10px;
  }

  .paragraph6 {
    z-index: 23;
    width: 350px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(66, 66, 66, 1);
    font-size: 14px;
    font-family: PingFangSC-Regular;
    line-height: 20px;
    text-align: left;
    align-self: flex-end;
    margin-top: 10px;
  }

  .paragraph7 {
    z-index: 25;
    width: 350px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(66, 66, 66, 1);
    font-size: 14px;
    font-family: PingFangSC-Regular;
    line-height: 20px;
    text-align: left;
    align-self: flex-end;
    margin-top: 10px;
  }

  .paragraph8 {
    z-index: 27;
    width: 350px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(66, 66, 66, 1);
    font-size: 14px;
    font-family: PingFangSC-Regular;
    line-height: 20px;
    text-align: left;
    align-self: flex-end;
    margin-top: 10px;
  }

  .bd2 {
    z-index: 29;
    position: absolute;
    left: 0;
    top: 131px;
    width: 375px;
  }
  button {
    margin: 0;
    padding: 0;
    border: 1px solid transparent;
    outline: none;
    background-color: transparent;
  }

  button:active {
    opacity: 1;
  }
  .flex-col {
    display: flex;
    flex-direction: column;
  }
  .flex-row {
    display: flex;
    flex-direction: row;
  }
  .search-input input {
    border: none; border-radius: 16px;background-color: rgba(250, 250, 250, 1);
  }
  .infoBox1:active{
    background: #EFEEF3;
  }
</style>



// WEBPACK FOOTER //
// invoiceTitleBox.vue?3ff75479